import React, { FC, MutableRefObject, useEffect, useRef } from 'react'
import { Form, Grid } from 'semantic-ui-react'
import { Dosage } from './ProductForm/Dosage'
import { Aliases } from './ProductForm/Aliases'
import { Details } from './ProductForm/Details'
import { Images } from './ProductForm/Images'
import { useForm, useFormState } from 'react-final-form'
import { AddAliasFromQuery } from './ProductForm/AddAliasFromQuery'
import { DeleteDuplicateAliases } from './ProductForm/DeleteDuplicateAliases'

export const ProductForm = ({
  productFormPristine,
  actions: Actions,
  enableAliasRemap,
}: {
  productFormPristine: MutableRefObject<boolean>
  actions: FC
  enableAliasRemap?: boolean
}) => {
  const createProductFormRef = useRef<HTMLFormElement>(null)
  const { submit } = useForm()
  const { pristine, values } = useFormState()

  useEffect(() => {
    productFormPristine.current = pristine
  }, [pristine, productFormPristine])

  return (
    <Form onSubmit={submit} id="create-product-form" ref={createProductFormRef}>
      <AddAliasFromQuery />
      <Form.Group style={{ justifyContent: 'flex-end' }}>
        <Actions />
      </Form.Group>
      <Grid stackable>
        <Grid.Column width={5}>
          <Details />
        </Grid.Column>
        <Grid.Column width={5}>
          <Dosage />
        </Grid.Column>
        <Grid.Column width={6}>
          <Images />
          <Aliases enableAliasRemap={enableAliasRemap} />
        </Grid.Column>
      </Grid>
      <DeleteDuplicateAliases key={values.aliases_attributes} />
    </Form>
  )
}
